import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "lola-framework-ui-test/src/styles";
import "@leapfinancial/kentucky-sdk/styles";
import App from "./App.tsx";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import "./locales/i18n.ts";
import "./styles/kapital.styles.css";
import posthog from "posthog-js";
import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react";
import { config } from "./config.ts";

// Import flavor system
import "./flavors/shared/base.css";
import "./flavors/flavor-a/styles.css";
import "./flavors/flavor-b/styles.css";
import "./flavors/flavor-c/styles.css";

const POSTHOG_KEY = config.POSTHOG_KEY ?? "";
const isPostHogEnabled =
  POSTHOG_KEY.length > 0 && !POSTHOG_KEY.startsWith("phc_REEMPLAZAR");

if (isPostHogEnabled) {
  posthog.init(POSTHOG_KEY, {
    api_host: config.POSTHOG_HOST,
    defaults: "2026-01-30",
    capture_pageview: true,
    capture_exceptions: true,
    capture_performance: {
      web_vitals: true,
    },
    session_recording: {
      maskAllInputs: true,
    },
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      {isPostHogEnabled ? (
        <PostHogProvider client={posthog}>
          <PostHogErrorBoundary>
            <App />
          </PostHogErrorBoundary>
        </PostHogProvider>
      ) : (
        <App />
      )}
    </BrowserRouter>
  </StrictMode>
);
